import axiosInstance from '../axiosInterceptor/axiosInstance'

const base = (orgId, streamId) => `v1/orgs/${orgId}/streams/${streamId}/ad-video`

// The ad video standing in for the stream: null (a 204) while the game is on air.
export const getAdVideo = (orgId, streamId) =>
  axiosInstance.get(base(orgId, streamId)).then((r) => (r.status === 204 ? null : r.data))
